export default "__VITE_ASSET__BxxOTefT__"